import { useQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

async function getDataSyncLogDetails(id) {
  if (!id) return {};

  const response = await defaultFetch(`/ArchiveProcessor/Logs/${id}`);

  return response;
}

export const queryKey = (id) => ['data-sync-logs', id];

export function useDataSyncLogDetails(id) {
  return useQuery({
    queryKey: queryKey(id),
    staleTime: 1000 * 30, // 30 seconds
    queryFn: async () => getDataSyncLogDetails(id)
  });
}
